import { useGetCurrentUserQuery } from "../store/services/userService";
import { UserRoleType } from "../store/services/userService";

export const useUserRoles = () => {
  const { data: currentUser, isLoading, error } = useGetCurrentUserQuery();

  const hasRole = (role: UserRoleType): boolean => {
    if (!currentUser?.Roles) return false;
    return currentUser.Roles.some(r => r.Type === role);
  };

  const hasAnyRole = (roles: UserRoleType[]): boolean => {
    if (!currentUser?.Roles) return false;
    return roles.some(role => hasRole(role));
  };

  const hasAllRoles = (roles: UserRoleType[]): boolean => {
    if (!currentUser?.Roles) return false;
    return roles.every(role => hasRole(role));
  };

  const isAdmin = (): boolean => {
    return hasAnyRole([
      UserRoleType.Admin,
      UserRoleType.CrmAdmin,
    ]);
  };

  const isSalesManager = (): boolean => {
    return hasAnyRole([
      UserRoleType.SalesAdmin,
      UserRoleType.ExternalSaleAdmin
    ]);
  };

  const isSalesPerson = (): boolean => {
    return hasAnyRole([
      UserRoleType.SalesPerson,
      UserRoleType.ExternalSale
    ]);
  };


  return {
    currentUser,
    isLoading,
    error,
    hasRole,
    hasAnyRole,
    hasAllRoles,
    isAdmin,
    isSalesManager,
    isSalesPerson,
  };
};